import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import i18next from '../../base/i18n/i18next';
import { setAuthenticated, setUserInfo } from '../../auth/actions';
import { authApi } from '../../auth/api';
const OfflinePage = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    // Load user info from cookies on mount and set to Redux
    useEffect(() => {
        if (authApi.isAuthenticated()) {
            const cachedUserInfo = authApi.getUserInfo();
            if (cachedUserInfo) {
                dispatch(setUserInfo(cachedUserInfo));
                dispatch(setAuthenticated(true));
            }
        }
    }, [dispatch]);
    // Set document direction based on current language
    useEffect(() => {
        const rtlLanguages = ['fa', 'ar', 'he'];
        const currentLang = i18next.language || 'fa';
        const isRtl = rtlLanguages.includes(currentLang);
        document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
        document.documentElement.lang = currentLang;
        const handleLanguageChanged = (lng) => {
            const newIsRtl = rtlLanguages.includes(lng);
            document.documentElement.dir = newIsRtl ? 'rtl' : 'ltr';
            document.documentElement.lang = lng;
        };
        i18next.on('languageChanged', handleLanguageChanged);
        return () => {
            i18next.off('languageChanged', handleLanguageChanged);
        };
    }, []);
    const handleRetry = useCallback(() => {
        window.location.reload();
    }, []);
    const handleGoBack = useCallback(() => {
        window.history.back();
    }, []);
    return (React.createElement("div", { className: 'static-page offline-page' },
        React.createElement("main", { className: 'static-page-content offline-content' },
            React.createElement("div", { className: 'offline-container' },
                React.createElement("div", { className: 'offline-icon' },
                    React.createElement("svg", { fill: 'currentColor', viewBox: '0 0 24 24' },
                        React.createElement("path", { d: 'M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2Zm1 14.5a1 1 0 1 1-2 0v-1a1 1 0 1 1 2 0Zm0-4a1 1 0 0 1-2 0v-5a1 1 0 0 1 2 0Z' }))),
                React.createElement("h1", { className: 'offline-title' }, t('offlineHtml.ConnectionNS')),
                React.createElement("p", { className: 'offline-description' }, t('offlineHtml.connectionServer')),
                React.createElement("div", { className: 'offline-actions' },
                    React.createElement("button", { className: 'offline-btn offline-btn--primary', onClick: handleRetry, type: 'button' }, t('offlineHtml.Retry')),
                    React.createElement("button", { className: 'offline-btn offline-btn--secondary', onClick: handleGoBack, type: 'button' }, t('offlineHtml.Return'))),
                React.createElement("div", { className: 'offline-hint' }, t('offlineHtml.check'))))));
};
export default OfflinePage;
